export default __webpack_public_path__ + "static/media/V490_E_BD.bd124e99.pdf";